import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

export const tempUrl = process.env.REACT_APP_API_URL;
export const tempUrlFico = process.env.REACT_APP_API_URL_FICO;

export const ContextProvider = ({ children }) => {
  const [screenSize, setScreenSize] = useState(undefined);

  return (
    <StateContext.Provider
      value={{
        screenSize,
        setScreenSize,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
